var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCultures(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 10.0961C18.25 14.5994 14.5994 18.25 10.0962 18.25C7.83688 18.25 6.14409 17.4819 4.84581 16.0968C3.53052 14.6935 2.5897 12.6235 1.92744 9.97486C1.33086 7.58889 0.728294 3.16223 0.550984 0.957245C0.53128 0.71221 0.721989 0.502825 0.988216 0.508598C2.76165 0.547057 5.88126 0.75806 9.95883 1.92306C12.0823 2.52974 14.1699 3.47149 15.7175 4.81777C17.2537 6.15414 18.25 7.87883 18.25 10.0961Z",
    stroke: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C16.25 14.375 11.25 8.75 7.5 7.5",
    stroke: "#393939",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCultures);
export default __webpack_public_path__ + "static/media/cultures.cddb387fe1f8695476660143fe549793.svg";
export { ForwardRef as ReactComponent };